module.exports = require("@nestjs/swagger");